export default "__VITE_ASSET__D7QOy61V__"